// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --title-color-outline: rgb(76,22,153);
  --title-color-text: rgb(249,104,240);
  --option-border-color: rgb(255,217,255);
  --option-border-color-hover: rgb(255,217,255);
  --option-border-color-chosen:rgb(249,104,240);
  --option-background-color: transparent;
  --option-background-color-hover: rgb(255,217,255);
  --option-background-color-chosen: rgb(249,104,240);
  --banner-color: darkorchid;
  --bright-text-color: white;
  --option-border-width: 2px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.wipe-away__title {
  margin: auto;
}

.wipe-away__logo {
  width: 90%;
  max-width: 1000px;
}

.selection {
  margin: auto;
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  border: 5px solid;
  border-color: var(--title-color-outline);
  min-width: 293px;
  width: fit-content;
  border-radius: 12px;
}

.selection-empty-text {
  max-width: 273px;
  min-height: 105px;
  padding: 10px;
  color: var(--banner-color);
  font-weight: 500;
}

.brand-choice {
  display: flex;
  width: 125px;
  height: 125px;
  justify-content: center;
  font-weight: 700;
}

.brand-choice-label {
  display: flex;
  justify-content: center;
  align-content: center;
  font-weight: 700;

}

.selection-properties {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}

.selection-property {
  margin: 2px;
  padding: 2px;
  width: 10em;
  height: 1.5em;
}

.style-choice {
  font-weight: 700;
  border-radius: 4px;
}

.rollSize-choice {
  font-weight: 700;
  border-radius: 4px;
}

.rollsInPack-choice {
  font-weight: 700;
  border-radius: 4px;
}

.unchosen {
  color: var(--title-color-text);
  border-style: dotted;
  border-color: var(--title-color-text);
  background-color: transparent;
  border-radius: 4px;
}

.chosen {
  color: var(--bright-text-color);
  border-style: solid;
  background-color: darkblue;
}

.unshow-second {
  display: none;
}

.show-second {
  font-size: 50px;
}

.instruction {
  color: var(--bright-text-color);
  background-color: darkorchid;
  font-size: 1.25em;
  font-weight: 700;
  margin: 5px auto;
}

input[type="radio"] {
  position: fixed;
  opacity: 0;
  width: 0px;
}

.brands {
  display: flex;
  justify-content: center;
  margin-top: 30px auto;
  flex-wrap: wrap;
}

.brand-choices {
  display: inline-flex;
  border: solid 2px transparent;
  max-width: 20%;
  max-height: 20%;
  width: 150px;
  margin: 2px 2px;
  border-radius: 8px;
  vertical-align: center;
  align-content: center;
}

.brand-choices-hidden {
  display: inline-flex;
  border: solid 2px transparent;
  max-width: 20%;
  max-height: 20%;
  width: 150px;
  margin: 2px 2px;
  border-radius: 8px;
  vertical-align: center;
  align-content: center;
  background-color: teal;
  visibility: hidden;
}

.brand-choices2 {
  display: inline-flex;
  border: solid 2px transparent;
  width: 150px;
  margin: 2px 2px;
  border-radius: 8px;
  align-content: center;
}

.brand-choices:hover {
  display: inline-flex;
  width: 150px;
  border: solid 2px purple;
  margin: 2px 2px;
  border-radius: 8px;
  align-content: center;
  box-shadow: 6px 6px 6px;
}

.active-brand {
  display: inline-flex;
  width: 150px;
  border: solid 2px blue;
  margin: 2px 2px;
  border-radius: 8px;
  align-content: center;
  box-shadow: 6px 6px 6px;
}

.brand-label {
  vertical-align: middle;
  display: flex;
}

.brandImg {
  max-width: 95%;
  max-height: 95%;
  margin: 0px 5px;
  object-fit: contain;
  vertical-align: middle;
  text-align: center;
}

.brandImg2 {
  display: table-cell;
  max-width: 140px;
  max-height: 110px;
  margin: 0px 5px;
  object-fit: contain;
  vertical-align: middle;
  text-align: center;
}


label {
  align-content: center;
  margin: 0px 0px;
}


.second-option__set_old {
  display: flex;
  flex-direction: row;
  border: 0px solid black;
  width: fit-content;
  margin: 0 auto;
  border-radius: 4px;
  font-size: 1.2em;
  font-weight: 600;
}

.second-option__set {
  display: flex;
  justify-content: center;
  margin-top: 30px auto;
  flex-wrap: wrap;
  font-size: 1.2em;
  font-weight: 600;
}

.second-option__individual{
  display:flex;
  flex-direction: column;
  width: 7em;
  margin: 5px;
  padding: 7px;
  border: var(--option-border-width) solid;
  border-radius: 12px;
  border-color: var(--option-border-color);
  justify-content: center;
}

.second-option__individual:hover{
  width: 7em;
  padding: 7px;
  margin: 5px;
  background-color: var(--option-background-color-hover);
  border-color: var(--option-border-color-hover);
  border: var(--option-border-width)px solid;
  border-radius: 12px;
}

/*
.second-option__individual:not(:last-child) {
  border-bottom: 1px solid black;
}
*/
.active-second {
  background-color: #61dafb;
}

.third-option__set_old {
  border: 1px solid purple;
  width: fit-content;
  margin: 20px auto;
  border-radius: 12px;
}

.third-option__set {
  display: flex;
  justify-content: center;
  margin-top: 30px auto;
  flex-wrap: wrap;
}

.third-option__individual {
  display: inline-block;
  width: 7em;
  margin: 5px;
  padding: 7px;
  height: 100%;
  font-size: 24px;
  border: 2px solid;
  border-radius: 12px;
  border-color: var(--option-border-color);
}

.third-option__individual:hover {
  display: inline-block;
  padding: 10px;
  width: 7em;
  margin: 5px;
  padding: 7px;
  height: 100%;
  font-size: 24px;
  border: 2px solid;
  border-radius: 12px;
  background-color: var(--option-background-color-hover);
  border-color: var(--option-border-color-hover);
}
/*
.third-option__individual:not(:last-child) {
  border-right: 1px solid purple;
}
*/
.active-third {
  border-color: var(--option-border-color-chosen);
  background-color: var(--option-background-color-chosen);
}

.rolls-in-pack-option__set {
  border: 0px solid black;
  width: fit-content;
  margin: 20px auto;
  border-radius: 4px;
}

.rolls-in-pack-option__individual {
  display: inline-block;
  padding: 2px;
  width: 1.5em;
  height: 100%;
  margin: 0px auto;
  font-size: 1.25em;
  font-weight: 700;
  border-radius: 4px;
  border: var(--option-border-width) solid;
  border-color: var(--option-border-color);
  text-align: center;
  color: rgb(96,96,96);
}

.rolls-in-pack-option__individual:hover {
  display: inline-block;
  padding: 2px;
  width: 1.5em;
  height: 100%;
  margin: 0px auto;
  font-size: 1.25em;
  font-weight: 700;
  border-radius: 4px;
  border: var(--option-border-width) solid;
  background-color: var(--option-background-color-hover);
  border-color: var(--option-border-color-hover);
  text-align: center;
  color: rgb(96,96,96);
  background-color: rgb(255, 217, 255);
}

/*
.active-rolls-in-pack {
  background-color: var(--option-background-color-chosen);
  border-color: var(--option-border-color-chosen);
}
*/

.rollsInPack-input {
  font-size: 2em;
  width: 2.5em;
  text-align: right;
}

.rollsInPack-confirm {
  border: 2px lightgray solid;
  border-radius: 4px;
  background-color: white;
  color: green;
  font-size: 2em;
  font-weight: 800;
}

.rollsInPack-label {
  font-size: 2em;
  margin: .25em;
}

.price{
  font-size: 2em;
  margin: .25em;
}

.price-input {
  font-size: 1em;
  margin: .25em;
  width: 4em;
}

.results-table {
  margin: auto;
  border: 0px gray solid;
  font-size: 1.25em;
  font-weight: 700;
}

.results-table-text {
  text-align: left;
  padding: 0 .1em;
}

.results-table-value {
  text-align: right;
  color: var(--title-color-outline);
}

/* Household controls */

.household-label {
  font-weight: 700;
}

.household-instructions {
  font-size: .8rem;
  font-weight: 600;
}

.household-selector-buttons {
  display:flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
}

.household-selector-buttons button {
  margin: 2px;
  border: 2px solid;
  border-color: var(--banner-color);
  border-radius: 4px;
  width: 1.75em;
  height: 1.75em;
  background-color: white;
  font-weight: 800;
  text-align: center;
  color: var(--banner-color);
}

.household-selector-buttons button:hover {
  background-color: var(--option-background-color-hover);
}

.male {
  filter: invert(.15) sepia(1) saturate(33) hue-rotate(210deg);
}

.female {
  filter: invert(.15) sepia(1) saturate(44) hue-rotate(312deg);
}

/* BidetWay Parent Controls */

.bidetway {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 800px;
  height: auto;
 /* width: 800;
 height: 200px;
 */
  gap: 20px;
}




/* BidetWay common attributes */

.bidet-div {
  height: 100%;
  flex-basis: 25%;
  flex-shrink: 1;
}

.bidet-div-grow {
  flex-grow: 1;
  max-width: 300px;
}

    /* show only if in portait square design */
.bidet-step-number {
  display: none;
}
@media (orientation: portrait) {
  .bidet-step-number {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    height: 25px;
    width: 25px;
    color: var(--bright-text-color);
    background-color: var(--banner-color);
    flex-shrink: 0;
    margin: 0 2px;
  }
}

/* BidetWay TP Spend Controls */

.bidetway-tp-spend {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 25%; /* don't shrink much */
  border: 4px solid;
  border-color: var(--banner-color);
  border-radius: 8px;
  box-sizing: border-box;
}

.bidet-title-text {
  height: fit-content;
  width: fit-content; 
}

.bidetway-tp-spend-amount {
  display: flex;
  font-weight: 1000;
  font-size: 64px;
  color: green;
}

/* (BidetWay) Household controls */

.household-selector-bidet {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  /*width: 150px;
  height: 200px;
  flex: 1 1 auto; */
}

.household-title-bidet {
  display: flex;
  height: 3em;
  font-weight: 700;
  margin: 0 10px;
  align-items: center;
}

.household-instructions-bidet {
  font-size: .66rem;
  font-weight: 600;
}

.household-members-bidet {
  display: flex;
  flex-direction: row;
  height: auto;
  width: 100%;
  flex-shrink: 0;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  max-height: 100px;
}

.household-selector-buttons-bidet {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  align-items: flex-start;
}

.household-selector-buttons-bidet button {
  margin: 2px;
  border: 2px solid;
  border-color: var(--banner-color);
  border-radius: 4px;
  width: 1.75em;
  height: 1.75em;
  font-weight: 800;
  text-align: center;
  color: var(--banner-color);
}

.household-selector-buttons-bidet button:hover {
  background-color: var(--option-background-color-hover);
}

/* At Home Controls */

.at-home-selector-bidet {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  /*width: 150px;
  height: 200px;
  flex: 1 1 auto;*/
}

.at-home-selector-title-bidet {
  display: flex;
  height: 3em;
  font-weight: 700;
  align-items: center;
  margin: 0 10px;
}

.at-home-selector-buttons-bidet {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex: 1 1 auto;
}

.at-home-selector-button {
  border: 2px solid;
  border-color: var(--banner-color);
  border-radius: 4px;
  background-color: var(--bright-text-color);
  color: var(--banner-color);
  font-weight: 600;
  text-align: center;
  margin: .25em 5px;
  width: 80px;
  height: 2em;
}

.at-home-selector-button:hover {

  background-color: var(--option-background-color-hover);
}

.at-home-selector-button.selected {
  color: var(--bright-text-color);
  background-color: var(--banner-color);
}

/* TP Class Controls */

.tpclass-selector-bidet {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  /*min-width: 150px;
  height: 200px;
  flex: 1 1 auto;*/
}

.tpclass-selector-title {
  display: flex;
  height: 3em;
  font-weight: 700;
  align-items: center;
  flex: none;
  margin: 0 10px;
}

.tpclass-selector-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
}

.tpclass-selector-button {
  border: 2px solid;
  border-color: var(--banner-color);
  border-radius: 4px;
  background-color: var(--bright-text-color);
  color: var(--banner-color);
  font-weight: 600;
  text-align: center;
  margin: .25em 5px;
  width: 100px;
  height: 2em;
}

.tpclass-selector-button:hover {
  background-color: var(--option-background-color-hover);
}

.tpclass-selector-button.selected {
  color: var(--bright-text-color);
  background-color: var(--banner-color);
}

@media (orientation: portrait) {
  .bidetway {
    height: 400px;
    width: 400px;
    flex-wrap: wrap;
  }

  .bidet-div {
    height: 50%;
    width: 40%;
    flex-basis: 40%;
    flex-shrink: 1;
  }
}



`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,uCAAuC;EACvC,6CAA6C;EAC7C,6CAA6C;EAC7C,sCAAsC;EACtC,iDAAiD;EACjD,kDAAkD;EAClD,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;EACjB,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;;AAElB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,qCAAqC;EACrC,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;;AAGA;EACE,qBAAqB;EACrB,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,mBAAmB;EACnB,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,sDAAsD;EACtD,8CAA8C;EAC9C,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;;;;CAIC;AACD;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;EACtD,8CAA8C;AAChD;AACA;;;;CAIC;AACD;EACE,+CAA+C;EAC/C,uDAAuD;AACzD;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,wCAAwC;EACxC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,sDAAsD;EACtD,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;;;;;CAKC;;AAED;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA,uBAAuB;;AAEvB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA,6BAA6B;;AAE7B;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,YAAY;CACb;;EAEC;EACA,SAAS;AACX;;;;;AAKA,+BAA+B;;AAE/B;EACE,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;IAEI,0CAA0C;AAC9C;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,+BAA+B;IAC/B,qCAAqC;IACrC,cAAc;IACd,aAAa;EACf;AACF;;AAEA,+BAA+B;;AAE/B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc,EAAE,sBAAsB;EACtC,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA,kCAAkC;;AAElC;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB;;mBAEiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,sDAAsD;AACxD;;AAEA,qBAAqB;;AAErB;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB;;kBAEgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,0CAA0C;EAC1C,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,WAAW;AACb;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA,sBAAsB;;AAEtB;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB;;kBAEgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,0CAA0C;EAC1C,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,eAAe;IACf,cAAc;EAChB;AACF","sourcesContent":[":root {\n  --title-color-outline: rgb(76,22,153);\n  --title-color-text: rgb(249,104,240);\n  --option-border-color: rgb(255,217,255);\n  --option-border-color-hover: rgb(255,217,255);\n  --option-border-color-chosen:rgb(249,104,240);\n  --option-background-color: transparent;\n  --option-background-color-hover: rgb(255,217,255);\n  --option-background-color-chosen: rgb(249,104,240);\n  --banner-color: darkorchid;\n  --bright-text-color: white;\n  --option-border-width: 2px;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.wipe-away__title {\n  margin: auto;\n}\n\n.wipe-away__logo {\n  width: 90%;\n  max-width: 1000px;\n}\n\n.selection {\n  margin: auto;\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  justify-content: center;\n  border: 5px solid;\n  border-color: var(--title-color-outline);\n  min-width: 293px;\n  width: fit-content;\n  border-radius: 12px;\n}\n\n.selection-empty-text {\n  max-width: 273px;\n  min-height: 105px;\n  padding: 10px;\n  color: var(--banner-color);\n  font-weight: 500;\n}\n\n.brand-choice {\n  display: flex;\n  width: 125px;\n  height: 125px;\n  justify-content: center;\n  font-weight: 700;\n}\n\n.brand-choice-label {\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  font-weight: 700;\n\n}\n\n.selection-properties {\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  justify-content: center;\n}\n\n.selection-property {\n  margin: 2px;\n  padding: 2px;\n  width: 10em;\n  height: 1.5em;\n}\n\n.style-choice {\n  font-weight: 700;\n  border-radius: 4px;\n}\n\n.rollSize-choice {\n  font-weight: 700;\n  border-radius: 4px;\n}\n\n.rollsInPack-choice {\n  font-weight: 700;\n  border-radius: 4px;\n}\n\n.unchosen {\n  color: var(--title-color-text);\n  border-style: dotted;\n  border-color: var(--title-color-text);\n  background-color: transparent;\n  border-radius: 4px;\n}\n\n.chosen {\n  color: var(--bright-text-color);\n  border-style: solid;\n  background-color: darkblue;\n}\n\n.unshow-second {\n  display: none;\n}\n\n.show-second {\n  font-size: 50px;\n}\n\n.instruction {\n  color: var(--bright-text-color);\n  background-color: darkorchid;\n  font-size: 1.25em;\n  font-weight: 700;\n  margin: 5px auto;\n}\n\ninput[type=\"radio\"] {\n  position: fixed;\n  opacity: 0;\n  width: 0px;\n}\n\n.brands {\n  display: flex;\n  justify-content: center;\n  margin-top: 30px auto;\n  flex-wrap: wrap;\n}\n\n.brand-choices {\n  display: inline-flex;\n  border: solid 2px transparent;\n  max-width: 20%;\n  max-height: 20%;\n  width: 150px;\n  margin: 2px 2px;\n  border-radius: 8px;\n  vertical-align: center;\n  align-content: center;\n}\n\n.brand-choices-hidden {\n  display: inline-flex;\n  border: solid 2px transparent;\n  max-width: 20%;\n  max-height: 20%;\n  width: 150px;\n  margin: 2px 2px;\n  border-radius: 8px;\n  vertical-align: center;\n  align-content: center;\n  background-color: teal;\n  visibility: hidden;\n}\n\n.brand-choices2 {\n  display: inline-flex;\n  border: solid 2px transparent;\n  width: 150px;\n  margin: 2px 2px;\n  border-radius: 8px;\n  align-content: center;\n}\n\n.brand-choices:hover {\n  display: inline-flex;\n  width: 150px;\n  border: solid 2px purple;\n  margin: 2px 2px;\n  border-radius: 8px;\n  align-content: center;\n  box-shadow: 6px 6px 6px;\n}\n\n.active-brand {\n  display: inline-flex;\n  width: 150px;\n  border: solid 2px blue;\n  margin: 2px 2px;\n  border-radius: 8px;\n  align-content: center;\n  box-shadow: 6px 6px 6px;\n}\n\n.brand-label {\n  vertical-align: middle;\n  display: flex;\n}\n\n.brandImg {\n  max-width: 95%;\n  max-height: 95%;\n  margin: 0px 5px;\n  object-fit: contain;\n  vertical-align: middle;\n  text-align: center;\n}\n\n.brandImg2 {\n  display: table-cell;\n  max-width: 140px;\n  max-height: 110px;\n  margin: 0px 5px;\n  object-fit: contain;\n  vertical-align: middle;\n  text-align: center;\n}\n\n\nlabel {\n  align-content: center;\n  margin: 0px 0px;\n}\n\n\n.second-option__set_old {\n  display: flex;\n  flex-direction: row;\n  border: 0px solid black;\n  width: fit-content;\n  margin: 0 auto;\n  border-radius: 4px;\n  font-size: 1.2em;\n  font-weight: 600;\n}\n\n.second-option__set {\n  display: flex;\n  justify-content: center;\n  margin-top: 30px auto;\n  flex-wrap: wrap;\n  font-size: 1.2em;\n  font-weight: 600;\n}\n\n.second-option__individual{\n  display:flex;\n  flex-direction: column;\n  width: 7em;\n  margin: 5px;\n  padding: 7px;\n  border: var(--option-border-width) solid;\n  border-radius: 12px;\n  border-color: var(--option-border-color);\n  justify-content: center;\n}\n\n.second-option__individual:hover{\n  width: 7em;\n  padding: 7px;\n  margin: 5px;\n  background-color: var(--option-background-color-hover);\n  border-color: var(--option-border-color-hover);\n  border: var(--option-border-width)px solid;\n  border-radius: 12px;\n}\n\n/*\n.second-option__individual:not(:last-child) {\n  border-bottom: 1px solid black;\n}\n*/\n.active-second {\n  background-color: #61dafb;\n}\n\n.third-option__set_old {\n  border: 1px solid purple;\n  width: fit-content;\n  margin: 20px auto;\n  border-radius: 12px;\n}\n\n.third-option__set {\n  display: flex;\n  justify-content: center;\n  margin-top: 30px auto;\n  flex-wrap: wrap;\n}\n\n.third-option__individual {\n  display: inline-block;\n  width: 7em;\n  margin: 5px;\n  padding: 7px;\n  height: 100%;\n  font-size: 24px;\n  border: 2px solid;\n  border-radius: 12px;\n  border-color: var(--option-border-color);\n}\n\n.third-option__individual:hover {\n  display: inline-block;\n  padding: 10px;\n  width: 7em;\n  margin: 5px;\n  padding: 7px;\n  height: 100%;\n  font-size: 24px;\n  border: 2px solid;\n  border-radius: 12px;\n  background-color: var(--option-background-color-hover);\n  border-color: var(--option-border-color-hover);\n}\n/*\n.third-option__individual:not(:last-child) {\n  border-right: 1px solid purple;\n}\n*/\n.active-third {\n  border-color: var(--option-border-color-chosen);\n  background-color: var(--option-background-color-chosen);\n}\n\n.rolls-in-pack-option__set {\n  border: 0px solid black;\n  width: fit-content;\n  margin: 20px auto;\n  border-radius: 4px;\n}\n\n.rolls-in-pack-option__individual {\n  display: inline-block;\n  padding: 2px;\n  width: 1.5em;\n  height: 100%;\n  margin: 0px auto;\n  font-size: 1.25em;\n  font-weight: 700;\n  border-radius: 4px;\n  border: var(--option-border-width) solid;\n  border-color: var(--option-border-color);\n  text-align: center;\n  color: rgb(96,96,96);\n}\n\n.rolls-in-pack-option__individual:hover {\n  display: inline-block;\n  padding: 2px;\n  width: 1.5em;\n  height: 100%;\n  margin: 0px auto;\n  font-size: 1.25em;\n  font-weight: 700;\n  border-radius: 4px;\n  border: var(--option-border-width) solid;\n  background-color: var(--option-background-color-hover);\n  border-color: var(--option-border-color-hover);\n  text-align: center;\n  color: rgb(96,96,96);\n  background-color: rgb(255, 217, 255);\n}\n\n/*\n.active-rolls-in-pack {\n  background-color: var(--option-background-color-chosen);\n  border-color: var(--option-border-color-chosen);\n}\n*/\n\n.rollsInPack-input {\n  font-size: 2em;\n  width: 2.5em;\n  text-align: right;\n}\n\n.rollsInPack-confirm {\n  border: 2px lightgray solid;\n  border-radius: 4px;\n  background-color: white;\n  color: green;\n  font-size: 2em;\n  font-weight: 800;\n}\n\n.rollsInPack-label {\n  font-size: 2em;\n  margin: .25em;\n}\n\n.price{\n  font-size: 2em;\n  margin: .25em;\n}\n\n.price-input {\n  font-size: 1em;\n  margin: .25em;\n  width: 4em;\n}\n\n.results-table {\n  margin: auto;\n  border: 0px gray solid;\n  font-size: 1.25em;\n  font-weight: 700;\n}\n\n.results-table-text {\n  text-align: left;\n  padding: 0 .1em;\n}\n\n.results-table-value {\n  text-align: right;\n  color: var(--title-color-outline);\n}\n\n/* Household controls */\n\n.household-label {\n  font-weight: 700;\n}\n\n.household-instructions {\n  font-size: .8rem;\n  font-weight: 600;\n}\n\n.household-selector-buttons {\n  display:flex;\n  flex-direction: row;\n  justify-content: center;\n  align-content: center;\n}\n\n.household-selector-buttons button {\n  margin: 2px;\n  border: 2px solid;\n  border-color: var(--banner-color);\n  border-radius: 4px;\n  width: 1.75em;\n  height: 1.75em;\n  background-color: white;\n  font-weight: 800;\n  text-align: center;\n  color: var(--banner-color);\n}\n\n.household-selector-buttons button:hover {\n  background-color: var(--option-background-color-hover);\n}\n\n.male {\n  filter: invert(.15) sepia(1) saturate(33) hue-rotate(210deg);\n}\n\n.female {\n  filter: invert(.15) sepia(1) saturate(44) hue-rotate(312deg);\n}\n\n/* BidetWay Parent Controls */\n\n.bidetway {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  max-width: 800px;\n  height: auto;\n /* width: 800;\n height: 200px;\n */\n  gap: 20px;\n}\n\n\n\n\n/* BidetWay common attributes */\n\n.bidet-div {\n  height: 100%;\n  flex-basis: 25%;\n  flex-shrink: 1;\n}\n\n.bidet-div-grow {\n  flex-grow: 1;\n  max-width: 300px;\n}\n\n    /* show only if in portait square design */\n.bidet-step-number {\n  display: none;\n}\n@media (orientation: portrait) {\n  .bidet-step-number {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    height: 25px;\n    width: 25px;\n    color: var(--bright-text-color);\n    background-color: var(--banner-color);\n    flex-shrink: 0;\n    margin: 0 2px;\n  }\n}\n\n/* BidetWay TP Spend Controls */\n\n.bidetway-tp-spend {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 25%; /* don't shrink much */\n  border: 4px solid;\n  border-color: var(--banner-color);\n  border-radius: 8px;\n  box-sizing: border-box;\n}\n\n.bidet-title-text {\n  height: fit-content;\n  width: fit-content; \n}\n\n.bidetway-tp-spend-amount {\n  display: flex;\n  font-weight: 1000;\n  font-size: 64px;\n  color: green;\n}\n\n/* (BidetWay) Household controls */\n\n.household-selector-bidet {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  /*width: 150px;\n  height: 200px;\n  flex: 1 1 auto; */\n}\n\n.household-title-bidet {\n  display: flex;\n  height: 3em;\n  font-weight: 700;\n  margin: 0 10px;\n  align-items: center;\n}\n\n.household-instructions-bidet {\n  font-size: .66rem;\n  font-weight: 600;\n}\n\n.household-members-bidet {\n  display: flex;\n  flex-direction: row;\n  height: auto;\n  width: 100%;\n  flex-shrink: 0;\n  flex-grow: 1;\n  align-items: center;\n  justify-content: center;\n  max-height: 100px;\n}\n\n.household-selector-buttons-bidet {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n  align-items: flex-start;\n}\n\n.household-selector-buttons-bidet button {\n  margin: 2px;\n  border: 2px solid;\n  border-color: var(--banner-color);\n  border-radius: 4px;\n  width: 1.75em;\n  height: 1.75em;\n  font-weight: 800;\n  text-align: center;\n  color: var(--banner-color);\n}\n\n.household-selector-buttons-bidet button:hover {\n  background-color: var(--option-background-color-hover);\n}\n\n/* At Home Controls */\n\n.at-home-selector-bidet {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  /*width: 150px;\n  height: 200px;\n  flex: 1 1 auto;*/\n}\n\n.at-home-selector-title-bidet {\n  display: flex;\n  height: 3em;\n  font-weight: 700;\n  align-items: center;\n  margin: 0 10px;\n}\n\n.at-home-selector-buttons-bidet {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  flex: 1 1 auto;\n}\n\n.at-home-selector-button {\n  border: 2px solid;\n  border-color: var(--banner-color);\n  border-radius: 4px;\n  background-color: var(--bright-text-color);\n  color: var(--banner-color);\n  font-weight: 600;\n  text-align: center;\n  margin: .25em 5px;\n  width: 80px;\n  height: 2em;\n}\n\n.at-home-selector-button:hover {\n\n  background-color: var(--option-background-color-hover);\n}\n\n.at-home-selector-button.selected {\n  color: var(--bright-text-color);\n  background-color: var(--banner-color);\n}\n\n/* TP Class Controls */\n\n.tpclass-selector-bidet {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  /*min-width: 150px;\n  height: 200px;\n  flex: 1 1 auto;*/\n}\n\n.tpclass-selector-title {\n  display: flex;\n  height: 3em;\n  font-weight: 700;\n  align-items: center;\n  flex: none;\n  margin: 0 10px;\n}\n\n.tpclass-selector-buttons {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1 1 auto;\n}\n\n.tpclass-selector-button {\n  border: 2px solid;\n  border-color: var(--banner-color);\n  border-radius: 4px;\n  background-color: var(--bright-text-color);\n  color: var(--banner-color);\n  font-weight: 600;\n  text-align: center;\n  margin: .25em 5px;\n  width: 100px;\n  height: 2em;\n}\n\n.tpclass-selector-button:hover {\n  background-color: var(--option-background-color-hover);\n}\n\n.tpclass-selector-button.selected {\n  color: var(--bright-text-color);\n  background-color: var(--banner-color);\n}\n\n@media (orientation: portrait) {\n  .bidetway {\n    height: 400px;\n    width: 400px;\n    flex-wrap: wrap;\n  }\n\n  .bidet-div {\n    height: 50%;\n    width: 40%;\n    flex-basis: 40%;\n    flex-shrink: 1;\n  }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
